import { Files, MoreVertical } from 'lucide-react';
import { forwardRef } from 'react';

import { cn } from '../../lib/utils';

export interface RelatedContextTagProps {
  label: string;
  /** Pre-formatted file count (e.g. "1.3K"). */
  count: string;
  isHighlighted?: boolean;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
  className?: string;
}

export const RelatedContextTag = forwardRef<HTMLDivElement, RelatedContextTagProps>(
  function RelatedContextTag(
    { label, count, isHighlighted, onMouseEnter, onMouseLeave, className },
    ref
  ) {
    return (
      <div className={cn('flex h-[28px] items-center', className)}>
        {/* Hoverable chip — only this surface opens the popover. */}
        <div
          ref={ref}
          className="flex cursor-pointer items-center gap-1"
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
        >
          <span
            className={cn('text-[12px] font-medium leading-[1.4]', isHighlighted && 'text-error')}
          >
            {label}
          </span>
          <Files aria-hidden="true" className="h-4 w-4 text-grey-500" strokeWidth={2} />
          <span className="text-[12px] font-normal leading-[1.4] text-grey-500 tabular-nums">
            {count}
          </span>
        </div>
        {/* Decorative separator — sits outside the hoverable chip with its own
            cursor-default margin so it never participates in the popover hover. */}
        <span aria-hidden="true" className="flex cursor-default items-center px-2">
          <MoreVertical className="h-3 w-3 text-grey-400" strokeWidth={2} />
        </span>
      </div>
    );
  }
);

RelatedContextTag.displayName = 'RelatedContextTag';
